import {
  useReferenceData,
  useReportBespoke,
  useTransactions,
} from "@iliotech/data-wire";
import { useParams } from "react-router-dom";
import { ReportWidgetProps } from "../../ReportWidgetProps";
import s from "./TransactionsWidget.module.scss";
import { observer } from "mobx-react-lite";
import { useTransactionsWidget } from "./hooks/useTransactionsWidget";
import { IllioTable, SimpleTable } from "src/main";
import moment from "moment";
import { useState } from "react";
import { IntervalPaginator } from "../IntervalPaginator/IntervalPaginator";

export const TransactionsWidget = observer(
  ({
    periodContext,
    isLandScape,
    cellId,
    pageId,
    width,
  }: ReportWidgetProps) => {
    const { portfolioId } = useParams();
    const { getAllocationLabel } = useReferenceData();
    const { generating } = useReportBespoke();
    const MAX_POSITIONS = 30; // Changed from 10 to 20 to double the amount of positions shown
    const { data } = useTransactions(
      portfolioId!,
      periodContext.periodForRequest?.from,
      periodContext.periodForRequest?.to
    );
    const { columns: overrideColumns } = useTransactionsWidget(cellId, pageId);
    const [startIndex, setStartIndex] = useState(0);

    const tableData = (data?.data?.content || []).map((t) => ({
      ...t,
      instrumentName: t.instrument?.name,
      instrumentCode: t.instrument?.code,
      countryCode: t.instrument?.countryCode,
      countryName: getAllocationLabel(t.instrument?.countryCode!),
    }));

    // Sort tableData by tradeTime in descending order
    const sortedTableData = [...tableData].sort((a, b) =>
      moment(b.tradeTime).diff(moment(a.tradeTime))
    );

    // Get the current chunk of data based on startIndex
    const paginatedData = sortedTableData.slice(
      startIndex,
      startIndex + MAX_POSITIONS
    );

    return (
      <div style={{ width }} className={s.positionsWidget}>
        {!generating && (
          <IntervalPaginator
            totalItems={sortedTableData.length}
            currentStart={startIndex}
            maxInterval={MAX_POSITIONS}
            onIntervalChange={setStartIndex}
          />
        )}
        <IllioTable
          data={paginatedData}
          columns={overrideColumns}
          useColumnChooser={false}
        />
      </div>
    );
  }
);
